import { Component } from "@angular/core";

import { SvgMixinComponent } from "../svg-mixin.component";

@Component({
  selector: "med-icon-google",
  templateUrl: "./med-icon-google.component.html",
})
export class MedIconGoogleComponent extends SvgMixinComponent {}
